import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import app from './modules/app'
import home from './modules/home'
import personal from './modules/personal'
import user from './modules/user'
export default new Vuex.Store({
  modules: {
    home,
    app,
    personal,
    user
  }
});
